module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bOyYa"))).then(() => parcelRequire('37nVf'));